import React from "react";
import { connect } from "react-redux";
import { BaseComponent } from "BaseComponent";
import { Row, Col } from "react-bootstrap";
import { selectSwatch, updateThemeColors } from "BrandingAction";
import { updateUnsavedChanges } from "DashboardMenuAction";

class Swatch extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      selected: props.data.selected,
    };
    this.selectSwatch = this.selectSwatch.bind(this);
  }

  selectSwatch = () => {
    //debugger;
    var newarr = [];
    this.props.colors.map((colordata, id) => {
      var newcolordata = { ...colordata, selected: false };
      if (colordata.color === this.props.data.color) {
        newcolordata = { ...colordata, selected: true };
      }
      newarr.push(newcolordata);
    });

    var newValue = { ...this.props.data, selected: true };

    this.props.onColorChange(newarr, newValue);

    if (!newValue.custom) this.props.updateUnsavedChanges();

    if (newValue.custom) {
      this.props.onCustomColorSelection();
      return;
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps) {
      if (this.props.data.selected !== nextProps.data.selected) {
        this.setState({ selected: nextProps.data.selected });
      }
    }
  }

  render() {
    var { custom } = this.props.data;
    var { selected } = this.state;
    return (
      <div>
        {custom ? (
          <div className="swatch-picker" onClick={this.selectSwatch}>
            <i className="fa fa-eyedropper"></i>
          </div>
        ) : (
          <div
            style={{
              backgroundColor: this.props.data.color,
              width: 27,
              height: 27,
              marginTop: 1,
              marginRight: 10,
            }}
            className={selected ? "swatch-selected" : "swatch"}
            onClick={this.selectSwatch}
          >
            {selected ? (
              <img
                className="swatch-tick"
                src="../../style/images/v2_icons/theme-tick.png"
              />
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    // colors:state.themeColors
  };
}

export default connect(mapStateToProps, {
  selectSwatch,
  updateUnsavedChanges,
  updateThemeColors,
})(Swatch);
